export { ValueLogos } from './ValueLogos';
